export default "__VITE_PUBLIC_ASSET__b7d5abb3__"